import { createClient } from '@supabase/supabase-js';
import { env } from './env';

const hasSupabaseConfigValue = Boolean(env.SUPABASE_URL && env.SUPABASE_ANON_KEY);

const supabaseInstance = hasSupabaseConfigValue
  ? createClient(env.SUPABASE_URL, env.SUPABASE_ANON_KEY, {
      auth: {
        detectSessionInUrl: false,
      },
    })
  : null;

export function getSupabase() {
  return supabaseInstance;
}

export function hasSupabaseConfig() {
  return hasSupabaseConfigValue;
}

export const supabase = supabaseInstance;
